<template>
  <v-dialog v-model="dialog" max-width="90%">
    <v-card>
      <v-card-title>
        <div class="row align-center pa-0">
          <div class="col headline">
            Detalhes da conta
            <template v-if="loading">Carregando...</template>
            <v-btn v-else-if="isBackoffice" text color="default" @click="getReport('extract')" :loading="loadingExtract">
              <v-icon left>mdi-file-excel-outline</v-icon> Extrato da conta
            </v-btn>          </div>
          <div class="col-auto pa-sm">
            <v-btn fab text color="default" @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-3 pb-6" v-if="account && account.name">
        <div class="row">
          <div class="col-8 col-md-6">
            <small><b>Fornecedor</b></small><br/>
            {{ account.name }}
          </div>
          <div class="col-4 col-md-2">
            <small><b>Conta Heppi</b></small><br/>
            {{ account.account_number }}
          </div>
          <div class="col-6 col-md-2">
            <small><b>Saldo</b></small><br/>
            {{ account.available_balance || 0 | price }}
          </div>
          <div class="col-6 col-md-2">
            <small><b>À liberar</b></small><br/>
            {{ account.unavailable_balance || 0 | price }}
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm">
            <h3 class="pb-3 pt-6">Titular da conta bancária</h3>
            <div class="row">
              <div class="col-12">
                <small><b>Nome Completo / Razão Social</b></small><br/>
                {{ account.owner.name }}
              </div>
              <div class="col-6">
                <small><b>CPF/CNPJ</b></small><br/>
                {{ account.owner.document | document }}
              </div>
              <div class="col-6">
                <small><b>Telefone</b></small><br/>
                {{ account.owner.phone_number | phone_number }}
              </div>
              <div class="col-12">
                <small><b>E-mail</b></small><br/>
                {{ account.owner.email }}
              </div>
              <div class="col-12">
                <small><b>Endereço</b></small><br/>
                {{ getAddress(account.owner.address) }}
              </div>
            </div>
          </div>
          <div class="col-12 col-sm">
            <h3 class="pb-3 pt-6">Dados da conta bancária</h3>
            <div class="row" v-if="account.owner && account.owner.bankData">
              <div class="col-6">
                <small><b>Banco</b></small><br/>
                {{ account.owner.bankData.name }}
              </div>
              <div class="col-6">
                <small><b>Agência</b></small><br/>
                {{ account.owner.bankData.agency }}
              </div>
              <div class="col-6">
                <small><b>Conta</b></small><br/>
                {{ account.owner.bankData.account_number }}
              </div>
              <div class="col-6">
                <small><b>Tipo</b></small><br/>
                {{ account.owner.bankData.type }}
              </div>
            </div>
            <div class="row" v-else-if="account.owner && account.owner.bank_data">
              <div class="col-6">
                <small><b>Banco</b></small><br/>
                {{ account.owner.bank_data.name }}
              </div>
              <div class="col-6">
                <small><b>Agência</b></small><br/>
                {{ account.owner.bank_data.agency }}
              </div>
              <div class="col-6">
                <small><b>Conta</b></small><br/>
                {{ account.owner.bank_data.account_number }}
              </div>
              <div class="col-6">
                <small><b>Tipo</b></small><br/>
                {{ account.owner.bank_data.type }}
              </div>
            </div>
            <div class="row" v-if="account.owner && account.owner.pix">
              <div class="col-6">
                <small><b>PIX</b></small><br/>
                {{ account.owner.pix.type }}: {{ account.owner.pix.pix }}
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'accountModal',
  props: {
    accountId: {
      type: String,
      default: null
    },
    accountData: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    dialog: false,
    loading: false,
    loadingExtract: false,
    accountInfo: null
  }),
  computed: {
    ...mapGetters(['isBackoffice']),
    account () {
      return { ...(this.accountInfo || {}), ...(this.accountData || {}) }
    }
  },
  watch: {
    accountId (val) {
      if (val) {
        this.dialog = true
        this.getData()
      } else {
        this.dialog = false
        this.accountInfo = null
      }
    },
    accountData (val) {
      if (val) {
        this.dialog = true
        this.getData()
      } else {
        this.dialog = false
        this.accountInfo = null
      }
    },
    dialog (val) {
      if (!val) {
        this.$emit('close')
      }
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    getData () {
      let vue = this
      vue.loading = true

      axios.get('accounts/' + vue.accountId + '?api_key=' + vue.accountId, { baseURL: 'https://payment-gateway-api.heppi.io/api/' })
        .then(response => {
          if (response.data) {
            vue.loading = false
            vue.accountInfo = response.data
          } else {
            vue.loading = false
            vue.dialog = false
            vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
            vue.invoiceData = null
          }
        })
        .catch(() => {
          vue.loading = false
          vue.dialog = false
          vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
          vue.accountInfo = null
        })
    },
    getAddress (address) {
      if (!address) return ''

      let fullAddress = ''
      fullAddress += address.street || 'Sem rua'
      if (address.number) fullAddress += ', ' + address.number
      if (address.complement) fullAddress += ', ' + address.complement
      if (address.neighborhood) fullAddress += ', ' + address.neighborhood
      if (address.city) fullAddress += ', ' + address.city
      if (address.state) fullAddress += ' - ' + address.state
      if (address.zip_code) fullAddress += ', CEP: ' + address.zip_code
      return fullAddress
    },
    getReport (type) {
      this.loading = true
      this.$store.dispatch('n8nApi', { method: 'GET', url: `94653405-8f0d-4b53-8460-d42d0310d1bd/${this.accountId}/${type}` })
        .then(data => {
          // 1. Create a temporary URL pointing to the Blob object
          const url = URL.createObjectURL(data)

          // 2. Create a hidden <a> element
          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = this.accountId + '-' + type // Sets the default file name

          // 3. Append to DOM, trigger click, and remove it
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)

          // 4. Release the allocated memory after a short delay
          setTimeout(() => {
            URL.revokeObjectURL(url)
          }, 100)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
